import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
    {
        name: '2022/03/01',
        R: 0.013033258,
        0.13: 0.13,
        baseline: 1
    },
    {
        name: '2022/03/02',
        R: 0.00990099,
        0.13: 0.13,
        baseline: 1
    },
    {
        name: '2022/03/03',
        R: 0.057282196,
        0.13: 0.13,
        baseline: 1
    },
    {
        name: '2022/03/04',
        R: 0.0874133258,
        0.13: 0.13,
        baseline: 1
    },
    {
        name: '2022/03/05',
        R: 0.0990099,
        0.13: 0.13,
        baseline: 1
    },
    {
        name: '2022/03/06',
        R: 0.017282196,
        0.13: 0.13,
        baseline: 1
    }
];


export class RValue extends Component {

    render() {
        return (
            <>
                <LineChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis datakey="base"/>
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="R" stroke="#8884d8" activeDot={{ r: 8 }} />                    
                    <Line type="monotone" dataKey="baseline" stroke="#82ca9d" />
                </LineChart>
            </>
        );
    }
}

export default RValue;
